/**
 * @generated SignedSource<<42869d72fb93a615f0e9a8af76c17ca2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type searchInfoQuery$variables = {};
export type searchInfoQuery$data = {
  readonly sessionInfo: {
    readonly member: {
      readonly spaceMemberships: {
        readonly nodes: ReadonlyArray<{
          readonly space: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"SpaceIndicator_space">;
          };
        }>;
      } | null;
    } | null;
  };
};
export type searchInfoQuery = {
  response: searchInfoQuery$data;
  variables: searchInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "searchInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionInfo",
        "kind": "LinkedField",
        "name": "sessionInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Member",
            "kind": "LinkedField",
            "name": "member",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SpaceMembershipConnection",
                "kind": "LinkedField",
                "name": "spaceMemberships",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpaceMembership",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "SpaceIndicator_space"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "searchInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionInfo",
        "kind": "LinkedField",
        "name": "sessionInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Member",
            "kind": "LinkedField",
            "name": "member",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SpaceMembershipConnection",
                "kind": "LinkedField",
                "name": "spaceMemberships",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SpaceMembership",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Color",
                            "kind": "LinkedField",
                            "name": "color",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "light",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "dark",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce8744e6a8099b53c126bce178e7041d",
    "id": null,
    "metadata": {},
    "name": "searchInfoQuery",
    "operationKind": "query",
    "text": "query searchInfoQuery {\n  sessionInfo {\n    member {\n      spaceMemberships {\n        nodes {\n          space {\n            id\n            ...SpaceIndicator_space\n          }\n          id\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment SpaceIndicator_space on Space {\n  id\n  name\n  color {\n    light\n    dark\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c5cd8f3aac1e129b02e6449dc3d2fe9";

export default node;
